import { EventEmitter } from 'events';

/**
 * @type {EventEmitter}
 */
export default EventEmitter;
